import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { ContentType } from 'api/contentful/contentTypes.cloverdotcom';
import { fetchEntries, IContentfulFilters } from 'api/contentful/fetchEntries';
import { ONE_HOUR_IN_MS } from 'globalConstants';
import { flattenContentfulData, FlatEntry } from 'services/cms/flattenContentful';
import { get } from 'utils/EntryUtil';
import { isValidLocale } from 'utils/Locales';

export function useSingleContentfulEntry<T extends object>(contentType: ContentType, include = 2) {
  const { language } = useTranslation().i18n;

  return useQuery(
    [contentType, `${include}`],
    () => fetchSingleEntry<T>(language, { contentType, include }),
    {
      staleTime: ONE_HOUR_IN_MS,
    },
  );
}

async function fetchSingleEntry<T extends object>(language: string, filter: IContentfulFilters) {
  if (!isValidLocale(language)) return;

  const entries = await fetchEntries<T>(language, filter);
  const [item] = get(entries, 'items', []);

  return flattenContentfulData(item) as FlatEntry<T>;
}
